<template>
	<div class="relative w-full h-full">
		<div class="rounded-2xl bg-neutral-100 flex items-center justify-center aspect-[328/336] sm:aspect-[751/519] overflow-hidden">
			<Swiper
				class="w-full h-full"
				:modules="[Navigation, Autoplay]"
				:autoplay="{
					delay: 10000,
					disableOnInteraction: true
				}"
				:slides-per-view="1"
				space-between="0"
				@slide-change="handleCurrentIndex"
				@swiper="onSwiper"
			>
				<SwiperSlide
					v-for="image in gallery"
					:key="image.id"
					class="w-full h-full"
				>
					<NuxtPicture
						v-if="image?.filename"
						provider="storyblok"
						:modifiers="image.focus ? {filters: {focal: image.focus}} : {}"
						:src="image.filename"
						:alt="image.alt || ''"
						class="block w-full h-full"
						:img-attrs="{class: 'block w-full h-full object-cover'}"
						sizes="818px sm:801px xl:1069px"
					/>
				</SwiperSlide>
			</Swiper>
		</div>
		<div class="flex max-md:justify-end mt-1">
			<div
				v-if="galleryLength > 1"
				class="flex md:absolute md:right-4 md:bottom-4 justify-end z-10"
			>
				<div class="inline-flex items-center gap-4 border border-border-tertiary shadow-xs rounded-full bg-white">
					<button
						type="button"
						class="rounded-full bg-white text-icon-primary hover:bg-background-secondary disabled:bg-white disabled:text-body-disabled p-2"
						@click="slidePrev()"
					>
						<NuxtIcon name="chevron-left" filled class="text-2xl" />
					</button>
					{{ swiperIndex + 1 }} z {{ galleryLength }}
					<button
						type="button"
						class="swiper-next rounded-full bg-white text-icon-primary hover:bg-background-secondary disabled:bg-white disabled:text-body-disabled p-2"
						@click="slideNext()"
					>
						<NuxtIcon name="chevron-right" filled class="text-2xl" />
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {Autoplay, Navigation} from 'swiper/modules';
	import type {Swiper as SwiperClass} from 'swiper/types';
	import {Swiper, SwiperSlide} from 'swiper/vue';
	import 'swiper/css';
	import 'swiper/css/navigation';
	import type {PageTypeRestaurantStoryblok} from '@/storyblok/types';

	type Props = {
		gallery: PageTypeRestaurantStoryblok['gallery'];
	};

	const props = defineProps<Props>();

	const swiperIndex = ref(0);
	const galleryLength = ref(props.gallery.length);
	const swiperInstance = shallowRef<SwiperClass | null>(null);

	function onSwiper(swiper: SwiperClass) {
		swiperInstance.value = swiper;
		handleCurrentIndex(swiper);
	}

	function handleCurrentIndex(e: SwiperClass) {
		swiperIndex.value = e.realIndex;
	}

	function slideNext() {
		swiperInstance.value?.slideNext();
	}

	function slidePrev() {
		swiperInstance.value?.slidePrev();
	}
</script>
